import { useEffect, useState } from 'react';
import { Country, CountryCode, languages } from '../../api';

const useLanguages = (countries: Country[], countryCode?: CountryCode) => {
  const [languages, setLanguages] = useState<{ label: string, code: string }[]>([]);
  const [defaultLanguage, setDefaultLanguage] = useState<{ label: string, code: string } | undefined>();

  useEffect(() => {
    const currentCountry = countries.find(c => c.code === countryCode);
    if (!currentCountry) return;

    const { language } = currentCountry;
    setLanguages(language.map(l => ({ code: l.code, label: l.label })));

    const defaultLang = language.find(l => l.default);
    if (defaultLang) {
      setDefaultLanguage({ label: defaultLang.label, code: defaultLang.code });
    } else {
      setDefaultLanguage({ label: language[0].label, code: language[0].code });
    }
  }, [countries, countryCode]);

  return { languages, defaultLanguage };
};
export default useLanguages;


export const getLanguages = (countries: Country[], countryCode?: CountryCode) => {
  const currentCountry = countries.find(c => c.code === countryCode);
  if (!currentCountry) return [];

  const { language } = currentCountry;
  return language.map(l => ({ code: l.code, label: l.label }));
}

export const getDefaultLanguageCode = (countries: Country[], countryCode?: CountryCode) => {
  const currentCountry = countries.find(c => c.code === countryCode);
  if (!currentCountry) return '';

  const { language } = currentCountry;
  const defaultLanguage = language.find(l => l.default) || language[0];
  return defaultLanguage.code;
}
